<template>
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" />

        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Item Name</label>
                  <input type="text"  v-model="form.itemname"/>
                </div>
              </div>

              <div class="col-lg-12 col-sm-6 col-12">
                <div class="form-group">
                  <label>Description</label>
                  <textarea class="form-control" v-model="form.itemdescription"></textarea>
                </div>
              </div>

              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Category</label>
                    <model-list-select
                      :list="categoryListFromApi"
                      v-model="form.itemcategory"
                      option-value="categoryid"
                      option-text="categoryname"
                      placeholder="Select category"
                    >
                    </model-list-select>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Unit</label>
                  <input type="text"  v-model="form.unit"/>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>UnitPrice</label>
                  <b-form-input type="number"  v-model="form.unitprice"/>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Available</label>
                  <input type="text"  v-model="form.available"/>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Threshold</label>
                  <input type="text"  v-model="form.threshold"/>
                </div>
              </div> 
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Rack Number</label>
                  <input type="text"  v-model="form.rack_no"/>
                </div>
              </div>

              <!-- <div class="col-lg-12">
                <div class="form-group">
                  <label>Item Images (Max {{ maxImages }})</label>
                  <input 
                    type="file" 
                    accept="image/*" 
                    multiple 
                    @change="handleImageUpload" 
                    ref="imageUploader" 
                    style="display: none;"
                  />
                  <div class="d-flex flex-wrap align-items-center">
                    <div v-for="(image, index) in localImages" :key="image.url || image.file.name" class="image-preview-container me-3 mb-3">
                      <img :src="image.url" class="img-thumbnail" alt="Item Image" style="width: 100px; height: 100px; object-fit: cover;"/>
                      <span class="remove-image-icon" @click="removeLocalImage(index)">×</span>
                      <span :class="['image-status-label', image.isNew ? 'bg-info' : 'bg-success']">
                        {{ image.isNew ? 'New' : 'Existing' }}
                      </span>
                    </div>

                    <div 
                      class="add-image-placeholder me-3 mb-3" 
                      @click="$refs.imageUploader.click()"
                      v-if="localImages.length < maxImages"
                    >
                      <i class="fas fa-plus"></i>
                      <span>Add Image</span>
                    </div>

                    <div v-if="localImages.length === maxImages" class="text-muted small">
                      (Maximum {{ maxImages }} images selected)
                    </div>
                  </div>
                  <small v-if="uploadError" class="text-danger">{{ uploadError }}</small>
                </div>
              </div> -->
              <div class="col-lg-12">
                <a v-on:click="postData()" class="btn btn-submit me-2">Submit</a>
                <router-link to="productlist" class="btn btn-cancel">Cancel</router-link>
              </div>
            </div>
          </div>
        </div>
        </div>
    </div>
  </div>
</template>
<script>
import { ModelListSelect } from "vue-search-select"
import axios from "axios";
import { mapGetters } from 'vuex';

async function ImageUploadApi(item_id, files) {
    const formData = new FormData();
    formData.append('item_id', item_id);
    files.forEach(file => {
        formData.append('image_files', file); 
    });
    
    const response = await axios.post(`/v1/items/${item_id}/images`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return response.data; 
}

async function ImageDeleteApi(itemId, url) {
    const response = await axios.delete(`/v1/items/${itemId}/images`, {
        data: { image_url: url } 
    });
    return response.data;
}

export default {
  data() {
    return {
      form: {
        itemname: '',
        itemdescription: '',
        itemcategory: '',
        categoryid: '',
        unit: '0',
        unitprice:'0',
        available: '0',
        threshold: '0',
        locationid:'',
        rack_no:'',
        item_images: [], 
      },
      localImages: [],
      imagesToDelete: [], 
      maxImages: 4,
      uploadError: '',
      filter: true,
      id: this.$route.query.id,
      title: "Item Edit Item",
      title1: "Edit a Item",
      categoryListFromApi: [],
    };
  },
  created(){
    this.fetchCategoryListFromApi();
  },
  computed:{
    ...mapGetters(['getCurrentLocation']),

    currentLocation() { return this.getCurrentLocation; },
    
    locationName() {
      const loc = this.currentLocation;
      return loc ? Object.keys(loc) : null;
    },
    locationId() {
      const loc = this.currentLocation;
      return loc ? loc.id: null;
    },
    newFilesToUpload() {
      return this.localImages.filter(img => img.isNew).map(img => img.file);
    }
  },
  methods: {
    loadImagesFromForm(urls) {
      if (!urls) return;
      this.localImages = urls.map(url => ({
        file: null, // No file object for existing images
        url: url,
        isNew: false
      }));
    },

    handleImageUpload(event) {
      const files = event.target.files;
      this.uploadError = '';
      if (!files.length) return;

      const currentCount = this.localImages.length;
      const spaceLeft = this.maxImages - currentCount;
      const filesToAdd = Array.from(files).slice(0, spaceLeft);

      if (filesToAdd.length < files.length) {
          this.uploadError = `You can only select up to ${this.maxImages} images. Only the first ${filesToAdd.length} were added.`;
      }
      
      filesToAdd.forEach(file => {
          if (file.type.startsWith('image/')) {
              const fileURL = URL.createObjectURL(file);
              this.localImages.push({
                  file: file,
                  url: fileURL,
                  isNew: true
              });
          } else {
              this.uploadError = 'Only image files are allowed.';
          }
      });

      event.target.value = null; 
    },

    removeLocalImage(index) {
        const image = this.localImages[index];
        if (!image.isNew) {
        this.imagesToDelete.push(image.url); 
    }
        
        if (image.file) {
           URL.revokeObjectURL(image.url);
        }
        this.localImages.splice(index, 1);
        
        if (this.localImages.length < this.maxImages) {
             this.uploadError = '';
        }
    },
    
    async deleteExistingImages(itemId) {
        // Sort indexes in descending order so deletion doesn't mess up subsequent indexes
        this.imagesToDelete.sort((a, b) => b - a);

        for (const url of this.imagesToDelete) { // Iterate over URLs
        try {
            await ImageDeleteApi(itemId, url); // Pass URL to the API
        } catch (error) {
                console.error(`Failed to delete image at index ${index}:`, error);
                Swal.fire({
                    title: 'Partial Deletion Error',
                    text: `Failed to delete an image from the server. Please check item images.`,
                    icon: 'warning',
                });
            }
        }
        this.imagesToDelete = [];
    },

    async uploadNewImages(itemId) {
        if (this.newFilesToUpload.length === 0) {
            console.log('No new images to upload.');
            return;
        }

        const filesToUpload = this.newFilesToUpload;
        
        try {
            // Call the API to upload new files
            const updatedUrls = await ImageUploadApi(itemId, filesToUpload); 
            console.log("Image Upload Success:", updatedUrls);

            // Reconcile local images after successful upload
            this.localImages = this.localImages.map(img => {
              // Mark all images as existing after a successful save
              return { ...img, isNew: false, file: null };
            });

        } catch (error) {
            console.error('Image Upload Error:', error);
            // Non-blocking failure
            Swal.fire({
                title: 'Item Saved, Image Upload Failed',
                text: 'The item details were saved, but there was an error uploading the new images.',
                icon: 'warning',
            });
        }
    },
    // --- End Image Handling Methods ---

    async fetchCategoryListFromApi() {
    try {
      const response = await axios.get(`/v1/category?locationid=${this.locationId}`);
      this.categoryListFromApi = response.data; 
    } catch (error) {
      console.error('Error fetching category list:', error);
      }
    },
    
    async postData() {
      if (!this.form.itemname) {
        Swal.fire("Please enter the item name");
        return;
      }
      if (!this.form.itemcategory) {
        Swal.fire("Please select a category");
        return;
      }
      
      try {
        await this.deleteExistingImages(this.id);
        
        const updateResponse = await axios.put(`/v1/items/${this.id}`, this.form);
        
        await this.uploadNewImages(this.id);
        
        Swal.fire("Item updated successfully");
        this.$router.push({ path: '/productlist' });

      } catch (error) {
        console.log(error);
        const errorMessage = error.response ? error.response.data.detail : error.message;
        Swal.fire(`Error updating item: ${errorMessage}`);
      }
    },

    async getProductById(id) {
      try {
        const response = await axios.get('/v1/items/'+id);
        this.form = response.data;
        
        if (this.form.item_images) {
           this.loadImagesFromForm(this.form.item_images);
        }
        
      } catch (error) {
        console.log(error);
        this.errored = true;
      }
    }
  },
  beforeMount() {
    this.id = this.$route.query.id
    this.getProductById(this.id);
  },
  // Lifecycle hook to clean up local URLs on component destruction
  beforeDestroy() {
    this.localImages.forEach(img => {
      if (img.file) {
        URL.revokeObjectURL(img.url);
      }
    });
  },
  components: {
    ModelListSelect
  },
  name: "editproduct",
};
</script>

<style scoped>
/* Scoped styles for the image feature */
.image-preview-container {
    position: relative;
    display: inline-block;
}

.remove-image-icon {
    position: absolute;
    top: -5px;
    right: -5px;
    background: red;
    color: white;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    cursor: pointer;
    font-weight: bold;
    font-size: 14px;
    padding: 0;
    z-index: 10;
}

.image-status-label {
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 1px 5px;
    font-size: 10px;
    color: white;
    border-top-right-radius: 4px;
    z-index: 5;
}

.add-image-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100px;
    height: 100px;
    border: 2px dashed #ccc;
    border-radius: 5px;
    cursor: pointer;
    color: #6c757d;
    transition: all 0.2s;
}

.add-image-placeholder:hover {
    border-color: #007bff;
    color: #007bff;
}

.add-image-placeholder i {
    font-size: 24px;
    margin-bottom: 5px;
}
</style>